import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'app-other-counties',
    templateUrl: './other-counties.component.html',
    styleUrls: ['./other-counties.component.scss'],
    standalone: false
})
export class OtherCountiesComponent {
  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   }  
}